import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Tag } from "src/models/TagModel";
import ModalWithForm, { FieldProps } from "src/components/ModalWithForm";
import { useState } from "react";
import { useCreateTagMutation } from "src/store/apis/Tags";
import { withRBAC } from "src/HOC/withRBAC";
import { CLAIMS } from "src/constants";

function CreateModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [createTag, { isLoading: isLoadingTags }] = useCreateTagMutation();

  const fields: FieldProps<Tag>[] = [
    {
      label: "English Name",
      name: "name",
      type: "text",
      inputProps: {
        name: "name",
      },
    },
    {
      label: "Arabic Name",
      name: "nameAr",
      type: "text",
      inputProps: {
        name: "nameAr",
      },
    },
  ];

  async function handleConfirm(formData: Tag) {
    try {
      await createTag({
        data: {
          id: 0,
          name: formData.name,
          nameAr: formData.nameAr,
        },
      }).then(() => {
        setIsModalOpen(false);
      });
    } catch (error) {
      // TODO: implement toaster
      console.error(error);
    }
  }
  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        type="default"
        className="bg-primary text-white"
      >
        <PlusOutlined />
        Create Tag
      </Button>
      <ModalWithForm
        open={isModalOpen}
        mode="create"
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        isLoading={isLoadingTags}
        title={<h3>Create Tag</h3>}
        fields={fields}
      />
    </>
  );
}

export default withRBAC(CreateModal, [CLAIMS.EDIT]);
